export default "__VITE_ASSET__DjBdEB_K__"